/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class SecurityScanExample {
  /**
  * Path to the example file or directory
  */
  'examplePath': string;
  /**
  * Type of the example (file or directory)
  */
  'type': SecurityScanExampleTypeEnum;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "examplePath",
      "baseName": "examplePath",
      "type": "string",
      "format": ""
    },
    {
      "name": "type",
      "baseName": "type",
      "type": "SecurityScanExampleTypeEnum",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SecurityScanExample.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum SecurityScanExampleTypeEnum {
  File = 'FILE',
  Directory = 'DIRECTORY'
}

